<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="600">
      <v-card>
        <v-card-title>
          <span class="headline">
            <v-icon class="pr-2">add_circle</v-icon>
            Add links
          </span>
        </v-card-title>
        <v-card-text>
          <v-form ref="add_links" data-vv-scope="add_links" lazy-validation>
            <v-layout row wrap>
              <v-flex xs12>
                <v-textarea
                  v-model="links"
                  label="links*"
                  hint="Enter links one per line or separated by commas"
                  v-validate="'required'"
                  data-vv-name="add_links.links"
                  :error-messages="errors.collect('add_links.links')"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-form>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="closeModal()">Close</v-btn>
          <v-btn color="primary" flat @click="saveLinks()" :loading="loading" :disabled="loading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'AddLinksModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: ['addLinksDialog', 'loading'],
  data () {
    return {
      dialog: this.addLinksDialog,
      links: '',
      dictionary: {
        en: {
          custom: {
            'add_links.links': {
              required: 'Please add links'
            }
          }
        }
      }
    }
  },
  mounted () {
    this.$validator.localize(this.dictionary)
    this.$validator.localize('en')
  },
  watch: {
    addLinksDialog: {
      handler () {
        this.dialog = this.addLinksDialog
      }
    },
    dialog: {
      handler () {
        this.$parent.$emit('addLinksDialog', this.dialog)
      }
    }
  },
  methods: {
    saveLinks () {
      this.$validator.validateAll('add_links').then(res => {
        if (res) {
          this.$parent.$emit('loading', true)

          let params = {
            links: this.linksToArray(this.links)
          }

          this.$store.dispatch('ADD_LINKS', params).then(res => {
            this.$toasted.show('Links was successfully added')
            this.$parent.$emit('loading', false)
            this.$parent.$emit('updateLinksList')
            this.closeModal()
          }, err => {
            console.log('login error', err)
            this.$parent.$emit('loading', false)
            this.$toasted.show('ADD_LINKS ERROR: ' + this.$services.getApiError(err), { type: 'error' })
          })
        }
      })
    },
    linksToArray (strLinks) {
      let arrLinks = []

      // check if there are some lines
      var match = /\r|\n/.exec(strLinks)

      if (match) {
        let arrLines = strLinks.match(/[^\r\n]+/g)
        arrLinks = arrLines.map((line) => {
          return line.split(',').map((link) => { return link.trim() })
        })
        // join arrays in array
        arrLinks = [].concat.apply([], arrLinks)
      } else {
        arrLinks = strLinks.split(',').map((link) => { return link.trim() })
      }

      // remove empty values
      arrLinks = arrLinks.filter((link) => {
        return link != null && link !== ''
      })

      // convert to format with period
      // arrLinks = arrLinks.map((link) => { return [link, 1] })

      return arrLinks
    },
    closeModal () {
      this.dialog = false
      setTimeout(() => {
        this.$validator.errors.clear('add_links')
      }, 500)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/add-links-modal/AddTagsModal.vue